function ContactCard() {
	return (
		<div className="contactCard">
			<div className="contactCardTexts">
				<p className="contactTitles">
					Get In Touch <br /> or Schedule a Visit
				</p>
			</div>
			<div className="emailTab">
				<i className="fa-solid fa-envelope"></i>
				<div>
					<a
						href="mailto:
trustcounselingc@gmail.com"
					>
						<p>trustcounselingc@gmail.com</p>
					</a>
				</div>
			</div>
			<div className="phoneTab">
				<i className="fa-solid fa-phone"></i>
				<a href="tel:+16393822717">
					<p>+1 (639) 382 2717</p>
				</a>
			</div>
			<div className="locationTab">
				<i className="fa-solid fa-location-dot"></i>
				<a href="https://maps.app.goo.gl/fyJv37pQ1dXrPhtT8?g_st=com.google.maps.preview.copy">
					<p>Canola Ave, Regina, SK, S4Y 0E8</p>
				</a>
			</div>
		</div>
	);
}

export default ContactCard;
